import { useQuery } from "@tanstack/react-query";
import { getClosures } from "../api";

/** The store's closure of one day, if the day has been closed yet. */
export const useDailyClosure = (storeId?: string, day?: string | null) =>
	useQuery({
		queryFn: () =>
			getClosures({
				"q[storeIdEq]": storeId,
				"q[kindEq]": "daily",
				"q[periodStartEq]": day,
			}),
		queryKey: ["closures", { storeId, kind: "daily", day }],
		enabled: !!storeId && !!day,
		select: ({ data }) => data[0] ?? null,
	});
